"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSection246sItem = {
    key: Key | null | undefined;
    /** Detected variants: "services-item-two bg-primary-transparent w-100 wow fadeInUp" | "services-item-two bg-success-transparent w-100 wow fadeInUp" | "services-item-two bg-pink-transparent w-100 wow fadeInUp" | "services-item-two bg-gray-transparent w-100 wow fadeInUp" | "services-item-two bg-secondary-transparent w-100 wow fadeInUp" | "services-item-two bg-orange-transparent w-100 wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" | "5s" | "6s" */
    dataWowDuration: string;
    /** Detected variants: "booking" | "lab" | "health care" | "medicine" | "home care" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/icons/booking.svg" | "/Templates/Doccure/img/icons/lab.svg" | "/Templates/Doccure/img/icons/doctor.svg" | "/Templates/Doccure/img/icons/health-care.svg" | "/Templates/Doccure/img/icons/medicine.svg" | "/Templates/Doccure/img/icons/home-care.svg" */
    src: string;
    /** Detected variants: "Book Appointment" | "Lab Testing Services" | "Talk to Doctor’s" | "Health Care Services" | "Medicines & Supplies" | "Home Care Services" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.booking" | "all_routes.home12" | "all_routes.doctorsGrid" | "all_routes.home" | "all_routes.home13" | "all_routes.home9" */
    href: string;
    /** Detected variants: "col-xl-2 col-lg-4 col-sm-6 d-flex" */
    divClassName?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "service-icon" */
    div0ClassName?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeTwoServiceSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection246sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSection246sItem) => Partial<ComponentProps<"h3">>);
    divDiv0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServiceSection246sItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    serviceSection246s: ServiceSection246sItem[];
    serviceSection246sItemWrapper?: (item: ServiceSection246sItem, content: ReactNode) => ReactNode;
    serviceSection246sRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSection246sLinkVisible?: boolean;
    serviceSection246sLinkRenderer?: (item: ServiceSection246sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection246sImageVisible?: boolean;
    serviceSection246sImageRenderer?: (item: ServiceSection246sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection246sH3Visible?: boolean;
    serviceSection246sH3Renderer?: (item: ServiceSection246sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection246sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServiceSection246sItem) => Partial<ComponentProps<typeof SmartLink>>);
    serviceSection246sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection246sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSection246sH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSection246sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwoServiceSectionGenerated: FC<HomeTwoServiceSectionGeneratedProps> = ({
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv0H30Link0LinkProps,
    sectionDiv0Div0ClassName,
    serviceSection246s,
    serviceSection246sItemWrapper,
    serviceSection246sRenderer,
    serviceSection246sLinkVisible,
    serviceSection246sLinkRenderer,
    serviceSection246sImageVisible,
    serviceSection246sImageRenderer,
    serviceSection246sH3Visible,
    serviceSection246sH3Renderer,
    serviceSection246sLinkProps,
    serviceSection246sImageProps,
    serviceSection246sH3Props,
}) => {
    return (
        <section className="section service-section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        serviceSection246s,
                        (item: ServiceSection246sItem) => (
                            <div className={item.divClassName ?? "col-xl-2 col-lg-4 col-sm-6 d-flex"} key={item.key}>
                                <div className={item.className} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName ?? "service-icon"}>
                                        {renderItemNode(serviceSection246sImageVisible, serviceSection246sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof serviceSection246sImageProps === "function" ? serviceSection246sImageProps(item) : (serviceSection246sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    {renderItemNode(serviceSection246sH3Visible, serviceSection246sH3Renderer, item, (
                                        <h3 {...(typeof serviceSection246sH3Props === "function" ? serviceSection246sH3Props(item) : (serviceSection246sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>
                                            {renderItemNode(serviceSection246sLinkVisible, serviceSection246sLinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof serviceSection246sLinkProps === "function" ? serviceSection246sLinkProps(item) : (serviceSection246sLinkProps ?? {}))} {...(typeof divDiv0H30Link0LinkProps === "function" ? divDiv0H30Link0LinkProps(item) : (divDiv0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                        </h3>
                                    ))}
                                </div>
                            </div>
                        ),
                        serviceSection246sItemWrapper,
                        serviceSection246sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTwoServiceSectionGenerated;
